import style from './style';

const Content = ({ children }) => (
	<div className={style.content}>
		{children}
	</div>
);

export default Content;
